var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.canIModerate)?_c('div',{class:[
    'absolute top-4',
    'flex flex-col',
    'w-[352px]',
    'rounded-lg',
    _vm.xContentModerationWarning ? 'bg-canary-500' : 'bg-light-ui-100 dark:bg-dark-ui-100',
    'shadow-elevation-3',
  ]},[(_vm.xContentModerationWarning)?_c('div',{class:['flex', 'space-s-2', 'ms-3.5', 'me-2', 'mt-2']},[_c('OzIcon',{class:['text-danger-100'],attrs:{"name":"warning_filled","size":18}}),_vm._v(" "),_c('div',{class:['text-dark-text-100', 'text-body-small']},[_vm._v("\n      "+_vm._s(_vm.warningText)+"\n    ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-between w-full h-10"},[_c('p',{class:[
        'ms-3.5',
        'text-body-extra-small',
        'text-dark-text-100',
        !_vm.xContentModerationWarning && 'dark:text-light-text-100',
      ]},[_vm._v("\n      "+_vm._s(_vm.__('This post requires approval'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"me-2 flex"},[_c('OzContainedButton',{staticClass:"me-2",attrs:{"size-preset":_vm.OzContainedButtonSizePreset.H24px,"color-scheme":_vm.OzContainedButtonColorScheme.SecondaryClear,"dark-mode":_vm.xContentModerationWarning ? false : 'auto',"text":_vm.__('Reject'),"disabled":_vm.isFrozen},on:{"click":function($event){return _vm.confirmModerationRejectPost({ postCid: _vm.expandedPost.cid })}}}),_vm._v(" "),_c('OzContainedButton',{attrs:{"size-preset":_vm.OzContainedButtonSizePreset.H24px,"color-scheme":_vm.OzContainedButtonColorScheme.Primary,"dark-mode":_vm.xContentModerationWarning ? false : 'auto',"text":_vm.__('Approve'),"disabled":_vm.isFrozen},on:{"click":function($event){return _vm.approvePost({ postCid: _vm.expandedPost.cid })}}})],1)])]):_c('p',{class:[
    'absolute top-4',
    'flex items-center justify-center',
    'px-3.5',
    'h-10',
    'rounded-lg',
    'bg-light-ui-200 dark:bg-dark-ui-200',
    'shadow-elevation-2',
    'text-body-extra-small italic',
    'text-dark-text-200 dark:text-light-text-200',
  ]},[_vm._v("\n  "+_vm._s(_vm.__('Awaiting approval'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }